<span class="pill">
  @if (icon) {
    <ion-icon class="pill__icon" [name]="icon" aria-hidden="true"></ion-icon>
  }
  <span class="pill__label"><ng-content></ng-content></span>
</span>
